export default "__VITE_ASSET__DQCjIiEn__"